import formStyles from '@/styles/Forms.module.scss'
import { useMemo } from 'react'

/**
 * 
 * Takes the message key and returns the matching terms &
 * conditions checkbox label component
 */

export interface PublicSciTermsProps {
  hasFollowUpMessage: boolean
  hasCustomTerms: boolean
  openModal?: Function
}

const PublicSciTerms = ({ 
  hasFollowUpMessage, 
  hasCustomTerms, 
  openModal 
}: PublicSciTermsProps) => {

  const handleAnchorClick = (e) => {
    e.stopPropagation()
    e.preventDefault()
    openModal()
  }

  const defaultMessage = (
    <span>By checking this box, I agree to receive SMS messages from NextMe related to my service. Message &amp; data rates may apply. Reply STOP to opt out at any time or HELP for support.</span>
  )

  const termsTrueFollowupFalseMessage = (
    <>
      <span>I've read and agree to the</span>{' '}
      <a onClick={handleAnchorClick}>Terms and Conditions</a>{' '}
      <span>of this form and consent to receive SMS messages from NextMe related to my service. Message &amp; data rates may apply. Reply STOP to opt out at any time or HELP for support.</span>
    </>
  )

  const termsTrueFollowupTrueMessage = (
    <>
      <span>I've read and agree to the</span>{' '}
      <a onClick={handleAnchorClick}>Terms and Conditions</a>{' '} 
      <span>of this form and consent to receive SMS messages from NextMe related to my service and a single marketing SMS after service is complete. Message &amp; data rates may apply. Reply STOP to opt out at any time or HELP for support.</span>
    </>
  )

  const termsFalseFollowupTrueMessage = (
    <>
      <span>By checking this box, I consent to receive SMS messages from NextMe related to my service and a single marketing SMS after service is complete. Message &amp; data rates may apply. Reply STOP to opt out at any time or HELP for support.</span>
    </>
  )

  const message = useMemo(() => {
    if (hasCustomTerms && !hasFollowUpMessage) {
      return termsTrueFollowupFalseMessage
    }

    if (hasCustomTerms && hasFollowUpMessage) {
      return termsTrueFollowupTrueMessage
    }

    if (!hasCustomTerms && hasFollowUpMessage) {
      return termsFalseFollowupTrueMessage
    }

    return defaultMessage
  }, [hasFollowUpMessage, hasCustomTerms])

  return (
    <>
      <div 
        className={formStyles.checkboxLabel} 
        style={{
          fontSize: '14px',
        }}
      >
        {message}
      </div>
    </>                       
  )
}

export default PublicSciTerms